import React from "react";
import styled from "styled-components";
import Textarea from "react-textarea-autosize";
import QuillEditor from "../../../general/QuillEditor";
import ToggleActionFormButtonContainer from "./ToggleActionFormButtonContainer";
const StyledCreateForm = styled.div`
  border-radius: .2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  position: relative;
  white-space: normal;
  padding: 1rem;
`;
const ClearedTextareaAutosize = styled(Textarea)`
  width: 100%;
  border: none;
  overflow: auto;
  outline: none;
  background: transparent;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none;
  line-height: 1rem !important;
`;
const ToggleActionForm = /*#__PURE__*/React.memo(({
  placeholder,
  text = "",
  onChange,
  closeForm,
  children,
  submit,
  editor,
  cypress
}) => {
  const onEnterPress = e => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      submit();
      closeForm();
    }
  };

  const renderInput = () => {
    if (editor === 'quill') {
      return /*#__PURE__*/React.createElement(QuillEditor, {
        value: text,
        onChange: e => onChange(e),
        cypress: `QuillEditor`
      });
    }

    return /*#__PURE__*/React.createElement(ClearedTextareaAutosize, {
      value: text,
      placeholder: placeholder,
      minRows: 1,
      autoFocus: true,
      onChange: e => onChange(e),
      onFocus: e => e.target.select(),
      onBlur: closeForm,
      onKeyDown: onEnterPress,
      className: 'textarea-autosize',
      cypress: `${cypress}TextAreaInput`
    });
  };

  return /*#__PURE__*/React.createElement(StyledCreateForm, {
    className: 'card-list'
  }, renderInput(), /*#__PURE__*/React.createElement(ToggleActionFormButtonContainer, {
    closeForm: closeForm
  }, children));
});
export default ToggleActionForm;